import { styled } from '../../Utilities';
import { ContextualMenuBase } from './ContextualMenu.base';
import { getStyles } from './ContextualMenu.styles';
/**
 * ContextualMenu description
 */
export var ContextualMenu = styled(ContextualMenuBase, getStyles, undefined, { scope: 'ContextualMenu' });
//# sourceMappingURL=ContextualMenu.js.map